import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "apply-settings-to-rooms-modal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_minimalRoomList = _resolveComponent("minimalRoomList")!
  const _component_hadrianModal = _resolveComponent("hadrianModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_hadrianModal, {
      ref: "applySettingsToRoomsModal",
      title: _ctx.$t('modal.applySettingsToRooms.selectRoomsTitle'),
      rightButtonText: _ctx.$t('rooms.edit.confirmApply'),
      rightButtonDisabled: _ctx.selectedRoomIds.length === 0,
      onRightButtonClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirm())),
      onLeftButtonClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancel())),
      variant: "wide"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_minimalRoomList, {
            rooms: _ctx.rooms,
            isSelected: _ctx.isRoomSelected,
            toggleSelection: _ctx.toggleAllRooms,
            onSelect: _ctx.onRoomSelect,
            allSelected: _ctx.areAllRoomsSelected,
            isSelectable: _ctx.isSelectable,
            loading: _ctx.isLoadingRooms
          }, null, 8, ["rooms", "isSelected", "toggleSelection", "onSelect", "allSelected", "isSelectable", "loading"])
        ])
      ], undefined, true),
      _: 1
    }, 8, ["title", "rightButtonText", "rightButtonDisabled"])
  ]))
}